import { accessToken } from '@/storages'
import type { Axios, InternalAxiosRequestConfig } from 'axios'

class AuthRequestInterceptor {
  activate(instance: Axios) {
    instance.interceptors.request.use(this.onFulfilled, this.onRejected)
  }

  private onFulfilled(config: InternalAxiosRequestConfig) {
    const token = accessToken.get()
    if (token) {
      config.headers['Authorization'] = `bearer ${token}`
    }

    return config
  }

  private onRejected(error: any) {
    return Promise.reject(error)
  }
}

export const authRequestInterceptor = new AuthRequestInterceptor()
